import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Draggable } from "react-beautiful-dnd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";

import BigCard from "./covers/BigCard";
import Card from "./covers/Card";
import VerboseCard from "./covers/VerboseCard";
import Carousel from "./covers/Carousel";
import VerboseCarousel from "./covers/VerboseCarousel";
import Highlight from "./covers/Highlight";
import Collection from "./covers/Collection";
import Default from "./covers/Default";

const DraggableSerieCard = (props) => {
  const navigate = useNavigate();
  const { serie, index, draggableId, imgType, onDeleteSerie } = props;

  const [showTools, setShowTools] = useState(false);

  const displayCover = (children) => {
    let imgName = serie.img;
    if (serie.ImgTypes && serie.ImgTypes.length > 0) {
      let indexImgType = serie.ImgTypes.findIndex(
        (el) => el.idTypeImg === Number(imgType)
      );
      imgName =
        indexImgType > -1 ? serie.ImgTypes[indexImgType].SerieImg.url : imgName;
    } else imgName = serie.imgCollection;

    const imgURL = `https://newbrand.s3.eu-west-3.amazonaws.com/series/${serie.uid}/couvertures/${imgName}`;
    const collectionURL = `https://newbrand.s3.eu-west-3.amazonaws.com/collections/${serie.uid}/${imgName}`;

    switch (imgType) {
      case 1:
        return (
          <BigCard img={imgURL} uid={serie.uid}>
            {children}
          </BigCard>
        );
      case 2:
        return (
          <Card img={imgURL} uid={serie.uid}>
            {children}
          </Card>
        );
      case 3:
        return (
          <VerboseCard
            img={imgURL}
            uid={serie.uid}
            category={
              serie.Genres && serie.Genres.length > 0 && serie.Genres[0]
                ? serie.Genres[0].name
                : "..."
            }
            title={serie.name}
          >
            {children}
          </VerboseCard>
        );
      case 4:
        return (
          <Carousel img={imgURL} uid={serie.uid}>
            {children}
          </Carousel>
        );
      case 5:
        let urlLogo = "";
        if (serie.ImgTypes) {
          const indexImgType = serie.ImgTypes.findIndex(
            (el) => el.code === "logo"
          );
          const logo =
            indexImgType > -1 ? serie.ImgTypes[indexImgType].SerieImg.url : "";
          urlLogo = `https://newbrand.s3.eu-west-3.amazonaws.com/series/${serie.uid}/couvertures/${logo}`;
        }
        return (
          <VerboseCarousel
            img={imgURL}
            urlLogo={urlLogo}
            uid={serie.uid}
            sumup={serie.Seasons[0].summary}
          >
            {children}
          </VerboseCarousel>
        );
      case 6:
        return (
          <Highlight img={imgURL} uid={serie.uid}>
            {children}
          </Highlight>
        );
      case 7:
        return (
          <Collection img={collectionURL} uid={serie.uid}>
            {children}
          </Collection>
        );
      case 8:
      default:
        return (
          <Default img={imgURL} uid={serie.uid}>
            {children}
          </Default>
        );
    }
  };

  const willDelete = () => {
    onDeleteSerie(index);
  };

  const navigateToSerie = () => {
    navigate(`/serie/${serie.id}/details/`, {
      state: { serie },
    });
  };

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided) => {
        return (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <div
              onMouseEnter={() => {
                setShowTools(true);
              }}
              onMouseLeave={() => {
                setShowTools(false);
              }}
            >
              {displayCover(
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Space.Compact
                    block
                    style={{
                      top: 0,
                      opacity: showTools ? 1 : 0,
                    }}
                  >
                    <Tooltip title="Supprimer">
                      <Button onClick={willDelete} icon={<DeleteOutlined />} />
                    </Tooltip>
                    <Tooltip title="Aller à la série">
                      <Button
                        onClick={navigateToSerie}
                        icon={<EditOutlined />}
                      />
                    </Tooltip>
                  </Space.Compact>
                  <div
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      padding: 10,
                      borderRadius: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 15,
                        aspectRatio: 1,
                        borderRadius: 200,
                        border: "2px solid white",
                        backgroundColor:
                          serie.statut === "admin" ||
                          serie.statut === "unavailable"
                            ? "#ff0000"
                            : "#00ff00",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default DraggableSerieCard;
